
    var riot = require('riot')
    
riot.tag2('debug-bar', '<section class="{show}"> <table> <tr> <th>width</th> <td>{width}</td> </tr> <tr> <th>height</th> <td>{height}</td> </tr> <tr> <th>htmlCls</th> <td>{htmlCls}</td> </tr> <tr> <th>ua</th> <td>{ua}</td> </tr> </table> </section>', 'debug-bar,[data-is="debug-bar"]{ display: block; } debug-bar section,[data-is="debug-bar"] section{ width: 250px; background-color: rgba(0,0,0,0.7); padding: 10px; color: #fff; font-size: 1.2rem; right: 10px; bottom: 10px; z-index: 9999; position: fixed; -webkit-backface-visibility: hidden; backface-visibility: hidden; } debug-bar section.is-show,[data-is="debug-bar"] section.is-show{ display: block; z-index: 999999; } debug-bar section table,[data-is="debug-bar"] section table{ width: 100%; } debug-bar section table th,[data-is="debug-bar"] section table th,debug-bar section table td,[data-is="debug-bar"] section table td{ text-align: left; line-height: 1.5; } debug-bar section table th,[data-is="debug-bar"] section table th{ width: 40px; white-space: nowrap; font-weight: normal; } debug-bar section table th:after,[data-is="debug-bar"] section table th:after{ content: \':\'; } debug-bar section table td,[data-is="debug-bar"] section table td{ padding-left: 10px; }', '', function(opts) {
    var self = this

    if( $.url().param("debug") === "true" ){
    } else {
      self.unmount();
    }

    self.width = $(window).width()
    self.height = $(window).height()
    self.htmlCls = $("html").attr("class")
    self.ua = navigator.userAgent

    $(window).on('load resize orientationchange', function(e){
      self.width = $(window).width()
      self.height = $(window).height()
      self.htmlCls = $("html").attr("class")
      self.ua = navigator.userAgent
      self.update()
    })

});
    
  


// WEBPACK FOOTER //
// ./_src/riot/debug-bar.tag